import { nameColumn } from "../../../../../layouts/Table/columns/nameColumn";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Avatar, Flex, Group } from "@mantine/core";
import MainTable from "../../../../../layouts/Table/MainTable";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import { useListingLoader } from "../../../../../components/hooks/ListingHooks";
import { IconChevronDown } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import {
  deleteFolder,
  editFolder,
  getFolders,
} from "../../../../../api/FolderAPI";
import dateColumn from "../../../../../layouts/Table/columns/dateColumn";
import ItemDeleter from "../../../../../components/TableComponents/ItemDeleter";
import SelectionDeleter from "../../../../../components/TableComponents/SelectionDeleter";
import { useListStore } from "../../../../../stores/ListStore";

const FoldersListing = ({
  type = "ContactList",
  mainUrl = "/contact-lists",
  keyword = "list",
  additional = "",
}) => {
  const lang = useLanguage((s) => s.language);
  const apiRef = useGridApiRef();

  const columns = useMemo(() => {
    return [
      nameColumn({
        disableLink: true,
        editFunction: () => editFolder,
        getDisabled: () => false,
        apiRef,
        minWidth: 200,
        flex: 1,
        leftSection: function (row) {
          return (
            <Avatar
              color="initials"
              name={row.name}
              radius={"md"}
              size={36}
              variant="filled"
            />
          );
        },
      }),
      {
        field: "number_of_items",
        headerName: "Eléments",
      },
      dateColumn(),
    ];
  }, [apiRef]);

  const loading = useListStore((s) => s.listingLoad);
  const setLoading = useListStore((s) => s.setListingLoad);
  const [rows, setRows] = useState([]);

  const actionsCell = useCallback(({ row }) => {
    return (
      <Group wrap="nowrap" gap={8}>
        <ItemDeleter
          title_bold={`${row.name} #${row.id}`}
          handleDelete={deleteFolder}
          deletedMessage={lang.components.folder_navigator.delete_success}
          id={row.id}
          onFinish={() => setLoading(true)}
          apiRef={apiRef}
        />

        <IconChevronDown size={24} opacity={0.4} />
      </Group>
    );
  }, []);

  const toolbarActions = useCallback(
    ({ selectedIds }) => {
      return (
        <>
          <SelectionDeleter
            handleDelete={deleteFolder}
            apiRef={apiRef}
            setTableLoading={setLoading}
            ids={selectedIds}
            setRows={setRows}
          />
        </>
      );
    },
    [apiRef]
  );

  const navigate = useNavigate();
  const handleRowClick = ({ row }) => {
    navigate(mainUrl + `/folder/${row.id}/${keyword}/none${additional}`);
  };

  useEffect(() => {
    setLoading(true);
  }, []);

  useListingLoader({
    loading,
    setLoading,
    listGetter: getFolders,
    responseField: "folders",
    setRows,
    getRows: (result) => result.filter((x) => x.type === type),
  });

  return (
    <Flex w={"100%"} pos={"relative"} flex={1}>
      <MainTable
        apiRef={apiRef}
        columns={columns}
        rows={rows}
        loading={loading}
        setLoading={setLoading}
        id={"list-table"}
        actionsCell={actionsCell}
        hasFolder
        actionsCellWidth={100}
        disableGotoPage
        disableVisibleColumns
        defaultPerPage={15}
        disablePerPage
        onRowClick={handleRowClick}
        toolbarActions={toolbarActions}
        tableSx={{
          "& .table-toolbar": {
            minWidth: 420,
          },
          "& .table-search": {
            marginLeft: keyword === "workflow" ? "650px" : 0,
          },
          "& .MuiDataGrid-pinnedColumnHeaders": {
            border: "none !important",
            background: "none !important",
          },
          "& .MuiDataGrid-pinnedColumns": {
            border: "none !important",
            background: "none !important",
          },
          "& .MuiDataGrid-cell": {
            border: "none !important",
            borderRadius: 8,
          },
          "& .MuiDataGrid-columnHeaders": {
            border: "none !important",
          },
          "& .MuiDataGrid-main": {
            border: "none !important",
            background: "none !important",
          },
          "& .table-row": {
            cursor: "pointer",
            borderRadius: 4,
            marginBottom: 1,
            background: "#fff !important",
            border: "1px solid var(--mantine-color-primary-1)",
          },
          "& .MuiDataGrid-pinnedColumns--right .table-row": {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            borderLeft: "none",
          },
          "& .MuiDataGrid-pinnedColumns--left .table-row": {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            borderRight: "none",
          },
          "& .MuiDataGrid-virtualScrollerRenderZone .table-row": {
            borderRadius: 0,
            borderTopRightRadius: "0 !important",
            borderBottomRightRadius: "0 !important",
          },
          "& .MuiDataGrid-selectedRowCount": {
            visibility: "hidden",
          },
          "& .MuiPagination-root": {
            left: 0,
            transform: "none",
          },
          "& .Mui-selected": {
            color: "",
          },
          "& .MuiDataGrid-footerContainer": {
            border: 0,
          },
        }}
      />
    </Flex>
  );
};

export default FoldersListing;
